import {
  getApprovalStatusLabel,
  getPlanningStatusLabel,
  getProcessingStatusLabel,
} from "../domain/order-status.js";

function normalizeStatus(status, fallback = "unknown") {
  return String(status || fallback)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9_-]+/g, "-");
}

export function ProcessingStatusBadge({ status, label }) {
  const normalizedStatus = normalizeStatus(status, "unknown");

  return (
    <span
      className={`status-badge status-badge--processing status-badge--processing-${normalizedStatus}`}
    >
      {label || getProcessingStatusLabel(status)}
    </span>
  );
}

export function ApprovalStatusBadge({ status, label }) {
  const normalizedStatus = normalizeStatus(status, "unknown");

  return (
    <span
      className={`status-badge status-badge--approval status-badge--approval-${normalizedStatus}`}
    >
      {label || getApprovalStatusLabel(status)}
    </span>
  );
}

export function PlanningStatusBadge({ status, label }) {
  const normalizedStatus = normalizeStatus(status, "unknown");

  return (
    <span
      className={`status-badge status-badge--planning status-badge--planning-${normalizedStatus}`}
    >
      {label || getPlanningStatusLabel(status)}
    </span>
  );
}